window.theme = window.theme || {};

theme.account = (function() {

	var MobileUpdateVerification = {
		profileRequestOTP: '/tools/promoproxy/api/public/profile-request-otp',
		profileUpdate: '/tools/promoproxy/api/public//profile-update'
	};

	var pwreg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?!.* ).{8,16}$/;
	var otpCountdown = 0;
	var $otpCountdown = $('#otpCountdown');
	var otpTimer = 0;
	var $btnRequestOTP = $('#register-request-otp');
	var errorCodes = [];

	function init() {
		initResetPW();
		showErrorForPWReset();
		setupLoginForm();
	}

	function getQueryParams() {

		var objURL = {};
			window.location.search.replace(
			new RegExp( "([^?=&]+)(=([^&]*))?", "g" ),
			function( $0, $1, $2, $3 ){
				objURL[ $1 ] = $3;
			}
		);
		return objURL;
	};

	function setupLoginForm(){

		// handle destination for login
		if ( $('#customer_login').length ) {
			var urlParamObj = getQueryParams();
			var redirectTo = document.referrer;
			if ( document.referrer.includes('/account') ){
				redirectTo = Shopify.routes.root+'account'
			}
			// check any url param
			if ( typeof urlParamObj.checkout_url !== 'undefined' ) {
				redirectTo = decodeURIComponent( urlParamObj.checkout_url );
			}
			$('#customer_login').find('input[name="checkout_url"]').val( redirectTo );

			if ( typeof urlParamObj.status !== 'undefined' ){
				if ( urlParamObj.status == 'update-relogin' ) {
					$('.relogin-msg').removeClass('hide');
				}
			}
		}
	}

	function showErrorForPWReset(){
		if( $('.reset-password-fail').length ) {
			$('form[action="/account/recover"]').find('.errors').prependTo('#customer_login');
		}
	}

	function initResetPW() {
		var $form = $('.js-form-reset-pw form');
		var $pwField1 = $('.js-reset-pw');
		var $pwField2 = $('.js-confirm-pw');
		$form.find('.js-reset-pw, .js-confirm-pw')
			.on('keyup', function(e){
				if(
					pwreg.test( $pwField1.val() ) == true
					&&
					pwreg.test( $pwField2.val() ) == true
					&&
					$pwField1.val() == $pwField2.val()
				) {
					$form.find('.js-submit')
						.attr('disabled',false)
						.attr('type','submit');
					$pwField2.removeClass('has-error');
					$('.error-PasswordConfirmation').toggleClass('hide', true);
				} else {
					$form.find('.js-submit')
						.attr('disabled',true)
						.attr('type','button');
        }
			});
		$form.find('.js-confirm-pw')
			.on('blur', function(){
				console.log('blur');
				if(
					!(
						pwreg.test( $pwField1.val() ) == true
						&&
						pwreg.test( $pwField2.val() ) == true
						&&
						$pwField1.val() == $pwField2.val()
					)
				){
					$pwField2.toggleClass('has-error', $pwField1.val() != $pwField2.val());
					$('.error-PasswordConfirmation').toggleClass('hide', $pwField1.val() == $pwField2.val() );
				} else {
					$pwField2.removeClass('has-error');
					$('.error-PasswordConfirmation').toggleClass('hide', true);
				}
			});

	}

	return {
		init: init
	};
})();
((function($){
	theme.account.init();
}))(jQuery);
